module.exports = __webpack_public_path__ + "media/images/vector-26@2x-b4a1a110ca328a71873314c21c601d9e.png";